import styled from '@emotion/styled'
import { stylesIf, themeColor } from 'utils/styles'
import { Button } from 'components/patterns'

const getHasMovedStyles = (props) => `
  background: ${themeColor('sAndGHasMovedBkgColor')(props)};
  
  * {
    background: transparent !important;
  }

`
export const StyledDragItem = styled.div((props) => {
  const { hasMoved } = props
  return `
    display: flex;
    flex-direction: row;
    width: 100%;

    ${stylesIf(hasMoved, getHasMovedStyles(props))}
  `
})

export const StyledDragHandle = styled.div((props) => {
  const {
    isDraggable,
    theme: {
      color: { blueAccent: hoverBgColor },
    },
  } = props
  return `
    display: flex;
    flex-direction: row;
    border-radius: 3px;
    align-items: center;
    justify-content: center;
    max-height: 20px;
    overflow: hidden;
    margin-right: 3px;

    ${
      isDraggable
        ? `
      &:hover {
        cursor: pointer;
        background-color: ${hoverBgColor} !important;
      }
    `
        : ''
    }
  `
})

export const IconBox = styled.div`
  width: 18px;
  height: 20px;
  overflow: hidden;
  display: flex;
  padding-top: 6px;
`

export const IndexBox = styled.div(({ addIconMargin }) => {
  return `
  width: 25px;
  display: flex;
  justify-content: left;
  align-items: center;
  ${stylesIf(addIconMargin, `margin-left: 18px`)}
`
})

const listItemGroupForcedStyles = `
  .collapsible-widget_title {
    padding-left: 22px;
  }
`
export const ListItem = styled.div((props) => {
  const { forceAlignmentStyles } = props
  return `
    ${stylesIf(forceAlignmentStyles, listItemGroupForcedStyles)}
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
  `
})

export const StyledButton = styled(Button)`
  &:hover {
    text-decoration: underline;
  }
`
